import {root} from '../../config';
import vue from 'vue';

function url(api) {
    return root + '/home/' + api;
}

/**
 * 获取选题
 * @return {*}
 */
export function api_getselected() {
    return vue.http({
        method: 'get',
        url: url('getselected'),
        // params:{
        //     data:data
        // }
    });
}

/**
 * 获取新闻
 * @return {*}
 */
export function api_getdata() {
    return vue.http({
        method: 'get',
        url: url('getdata'),
    });
}

/**
 * 获取专家评委
 * @return {*}
 */
export function api_gettechlogo() {
    return vue.http({
        method: 'get',
        url: url('gettechlogo'),
        // params:{
        //     data:data
        // }
    });
}


/**
 * 获取登录状态
 * @return {*}
 */
export function api_getstate() {
    return vue.http({
        method: 'get',
        url: url('getstate'),
    });
}


/**
 * 获取专家评委
 * @return {*}
 */
export function api_getworks(id) {
    // console.log(id)
    return vue.http({
        method: 'get',
        url: url('getworks'),
        params:{
            id:id
        }
    });
}
